import React, {useRef, useState, useEffect} from 'react';
import {createPortal} from 'react-dom';
import './Modal.css';

export function Modal({trigger, triggerWrap, open, onClose, isStatic, isFlow, isWide, handleOpen, children, forControl}) {
  const [active, setActive] = useState(false);
  const refOverlay = useRef(null);
  const refTrigger = useRef(null);

  useEffect(() => {
    if (typeof open !== 'undefined' && open !== active) {
      setActive(open);
    }
  }, [open, active]);

  const handleActive = (value) => {
    if (isStatic) {
      handleOpen(value);
      return;
    }
    setActive(value);
    if ((!value || isFlow) && typeof onClose === 'function') {
      onClose();
    }
  };

  const handleOutsideClick = (e) => {
    if (isStatic) {
      return;
    }
    if (!refOverlay || !refOverlay.current || !refOverlay.current.contains(e.target)) {
      return;
    }
    handleActive(false);
  };

  const handleTriggerClick = (e) => {
    if (!refTrigger || !refTrigger.current || !refTrigger.current.contains(e.target)) {
      return;
    }
    handleActive(true);
  };

  return <React.Fragment>
    {trigger && triggerWrap && <div ref={refTrigger} className="modal__trigger--right" onClick={handleTriggerClick}>{trigger}</div>}
    {trigger && !triggerWrap && <span ref={refTrigger} onClick={handleTriggerClick}>{trigger}</span>}
    {createPortal(
    <React.Fragment>
      {active && <div className={"modal" + (active ? " modal--active" : "")}>
        <div className={"modal__wrapper" + (forControl ? " for-control":"") + (isWide ? " modal--wide" : "")}>
          {children}
          <div className="modal__close" onClick={() => handleActive(false)}></div>
        </div>
      </div>}
      <div className={"modal-overlay" + (active ? " modal-overlay--active" : "")} ref={refOverlay} onClick={handleOutsideClick}></div>
    </React.Fragment>,
    document.body
    )}
    </React.Fragment>;
};
